
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { EvTooltipSimpleComponent } from "src/app/shared-components/ev-tooltip-simple/ev-tooltip-simple.component";
import { RightSidebarOptions, RightSidebarService } from "src/services/right-sidebar.service";
import { FreedrawButtonsComponent } from "../freedraw-buttons/freedraw-buttons.component";
import { MapMode, MapStateService } from "src/services/map/map-state.service";
import { MarketSalesStateService } from "src/services/estate/market-sales-state.service";
import { NgClass } from "@angular/common";
import { OverviewFavoriteListsStore } from "src/stores/overview-favorite-lists.store";
import { SelectedFavoriteListsStore } from "src/stores/selected-favorite-list.store";

@Component({
    selector: "map-right-menu-buttons",
    imports: [EvTooltipSimpleComponent, FreedrawButtonsComponent, NgClass],
    templateUrl: "./map-right-menu-buttons.component.html",
    styleUrl: "./map-right-menu-buttons.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapRightMenuButtonsComponent {
    visibleButtons = input<RightSidebarOptions[]>([]);
    canShowFreedrawButtons = input<boolean>(false)
    rightSidebarOptions = RightSidebarOptions;
    mapMode = MapMode;
    freedrawMobileExpanded = false;

    private readonly rightSidebarService = inject(RightSidebarService);
    private readonly overviewFavoriteListStore = inject(OverviewFavoriteListsStore);
    private readonly selectedFavoriteListStore = inject(SelectedFavoriteListsStore);
    mapStateService = inject(MapStateService);
    marketSalesStateService = inject(MarketSalesStateService);

    isFilterDirty = computed(() => this.overviewFavoriteListStore.isFavoriteListOpen() ? this.selectedFavoriteListStore.filtersChanged() : this.marketSalesStateService.isDirty());

    filterForm = this.marketSalesStateService.filterForm;

    toggleVisibility(option: RightSidebarOptions) {
        this.rightSidebarService.toggleSidebarVisibility(option);        
    }
}
